/**
 * Application Configuration
 * 
 * Central configuration for the Nice Ice application.
 * All shared configuration values should be defined here.
 */

// Contact Information
export const contactInfo = {
  // WhatsApp Configuration
  whatsapp: {
    phoneNumber: '972505880446', // Update this number as needed
    businessName: 'Nice Ice'
  },
  
  // Contact Details
  phone: '0505880446',
  email: 'contact@niceice.cc',
  
  // Social Media
  social: {
    // Add social media links here if needed
  }
};

// Product Information
export const productInfo = {
  sizes: [
    { label: '2 ק"ג', value: '2kg' },
    { label: '6 ק"ג', value: '6kg' }
  ],
  
  // Other product details can be added here
};

// Create a named object for export
const appConfig = {
  contactInfo,
  productInfo
};

export default appConfig; 